<template>
	<div class="My_pop _popRight" id="POP-collection" style="display: block;"><!-- POP -->
		<div class="pop_right" style="right: 0px;"><!-- pop_right -->
			
			<ul class="pop_right_header2">
				<li><h2>我的收藏</h2></li>
				<li><btn class="pop_right_close2" name="pop-close" @click="closeFloat"></btn></li>
			</ul>
			
			<div class="MyTrack_tool">
				<div class="L">
					<div class="ml_1 info_txt" >全部<font class="red">{{totalResultCount}}</font>条收藏文章</div>
				</div>
			</div>
			
			
			
			<div class="pop_right_main"><!-- main -->
			
						<ul  class="list1b"  >
							<li v-for="(item,index) in resultDataList">
								<router-link :to="{ name: 'detail', params: { id: item.articleid }}" style="font-weight: bold;" target="_blank">
									{{item.title}}</router-link>
								<R>
									<el-popconfirm @confirm="removefavo(item.id)" title="确定要删除此条收藏吗？">
									  <i slot="reference" class="cei-icon icon-collect"></i>
									</el-popconfirm>
								</R>
							</li>
							<!-- <li><a href=""  >国常会决定带量采购“提速扩面”，高值医用耗材纳入集采成趋势高值医用耗材纳入集采成趋势</a><R><i class="cei-icon icon-collect"></i></R></li>
							<li><a href=""  >多地密集发布重大项目，新基建与新能源成为重要增长点</a><i class="cei-icon icon-collect"></i></li>
							<li><a href=""  >IMF警示脆弱新兴经济体：即刻为潜在的经济动荡做准备</a><i class="cei-icon icon-collect"></i></li>
							<li><a href=""  >刘和平：拜登对华科技战转向“精准脱钩”</a><i class="cei-icon icon-collect"></i></li> -->
						</ul>
										
										
			</div><!-- /main -->
			
			<div class="pop_right_footer2">
					<!-- <ul class="pages">
						<li class="p- p-pre p-grey"><a href="" class="cei-icon icon-pre"></a></li>
						<li class="p- p-curr"><a href="">1</a></li>
						<li class="p- "><a href="">2</a></li>
						<li class="p-"><a href="">3</a></li>
						<li class="p-"><a href="">4</a></li>
						<li class="p-"><a href="">5</a></li>
						<li class="p-more "><a href="" class="cei-icon icon-more"></a></li>
						<li class="p-"><a href="">10</a></li>
						<li class="p- p-next "><a href="" class="cei-icon icon-next"></a></li>
					</ul> -->
					<el-row class="pagediv">
						<el-pagination @size-change="changePageSize" @current-change="changeSearchPage" :current-page="pageNum"
							:page-sizes="[10, 30, 50]" :page-size="10" layout="prev, pager, next"
							:total="totalResultCount">
						</el-pagination>
					</el-row>
			</div>
			
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.getFavoritefnc();
			this.$track([
				['pagetype','我的收藏']
			]);
		},
		methods: {
			getFavoritefnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstFavorites',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							type:1,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.tempResult.artLst;
						_this.totalResultCount = response.data.data.data.tempResult.totalCount;
						_this.loadingMask = false;
						_this.$emit('senddata',_this.totalResultCount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			removefavo: function(id) {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/DelFavorites',
						responseType: 'json',
						params: {
							id: id,
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','删除收藏'],
								['pageid',_this.articleid]
							]);
							_this.changeSearchPage(1);
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getFavoritefnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.getFavoritefnc();
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
		},
	}
</script>

<style>
</style>
